import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle, CreditCard } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { bookingStore } from "@/domain/booking/booking.store";

const paymentSuccessSearchSchema = z.object({
  session_id: z.string().optional(),
});

export const Route = createFileRoute("/(public)/payment/success")({
  component: RouteComponent,
  validateSearch: paymentSuccessSearchSchema,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { clearBooking } = bookingStore();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // Nettoyer le store car le paiement est réussi
    clearBooking();
  }, [clearBooking]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate({ to: "/dashboard" });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-emerald-50">
      <div className="text-center max-w-lg mx-auto px-4">
        <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>

        <h1 className="font-h1 text-green-600 mb-4 text-3xl">
          Paiement réussi ! 🎉
        </h1>

        <p className="font-p text-muted-foreground mb-6 text-lg">
          Félicitations ! Votre réservation a été confirmée avec succès. Vous
          allez recevoir un email de confirmation dans quelques minutes.
        </p>

        <div className="bg-white p-6 rounded-lg shadow-md mb-8 border border-green-200">
          <div className="flex items-center justify-center gap-2 mb-3">
            <CreditCard className="w-5 h-5 text-green-600" />
            <span className="font-semibold text-green-700">
              Réservation confirmée
            </span>
          </div>
          <p className="text-sm text-muted-foreground">
            Votre chef va être notifié et vous contactera prochainement pour
            finaliser les détails.
          </p>
        </div>

        <p className="font-p text-muted-foreground mb-8">
          Redirection automatique vers votre dashboard dans {countdown} seconde
          {countdown > 1 ? "s" : ""}...
        </p>

        <div className="space-y-4">
          <Button asChild className="w-full">
            <Link to="/dashboard">Voir mes réservations</Link>
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to="/">Retour à l'accueil</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
